import React from 'react';
import LocationTemplate from './LocationTemplate';

const WavesPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Waves"
      stateName="North Carolina"
      countyName="Dare"
      zipCodes={["27982"]}
      latitude={35.4068}
      longitude={-75.4496}
      population={147}
      historicalFact="Named for the Atlantic Ocean waves, part of the Chicamacomico Life-Saving Station area."
      nearbyTowns={[
        "Salvo, NC",
        "Rodanthe, NC",
        "Avon, NC",
        "Chicamacomico, NC",
        "Pea Island, NC",
        "Buxton, NC",
        "Frisco, NC",
        "Hatteras, NC"
      ]}
    />
  );
};

export default WavesPage;